// /src/components/Footer.jsx
import React from 'react';
import { Linkedin, Github, Calendar } from 'lucide-react';
import { mutedText, sectionLabel } from './styles';

export default function Footer() {
  return (
    <footer className="mt-20" style={{ background: 'var(--card)', color: 'var(--text)' }}>
      <hr className="section-rule" />
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <p className={`${sectionLabel} mb-4`}>{'// contact'}</p>
            <div className={`space-y-2 ${mutedText}`}>
              <p>dlaurenzi@domeniclaurenzi.com</p>
              <p>Derby, Vermont</p>
            </div>
          </div>
          <div>
            <p className={`${sectionLabel} mb-4`}>{'// connect'}</p>
            <div className="space-y-2">
              <a href="https://linkedin.com/in/dlaurenzi" className="flex items-center gap-2 hover:opacity-90 transition text-[var(--accent)]">
                <Linkedin size={20} /> LinkedIn
              </a>
              <a href="https://github.com/hackingpain" className="flex items-center gap-2 hover:opacity-90 transition text-[var(--accent)]">
                <Github size={20} /> GitHub
              </a>
              <a href="https://calendly.com/dlaurenzi" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-90 transition text-[var(--accent)]">
                <Calendar size={20} /> Book a Call
              </a>
            </div>
          </div>
          <div>
            <p className={`${sectionLabel} mb-4`}>{'// security'}</p>
            <div className="space-y-2">
              <a href="/keys/pgp_public_key.asc" className="block hover:opacity-90 transition text-[var(--accent)]">PGP Key</a>
              <a href="/.well-known/security.txt" className="block hover:opacity-90 transition text-[var(--accent)]">security.txt</a>
              <a href="/policies/responsible-disclosure.html" className="block hover:opacity-90 transition text-[var(--accent)]">Responsible Disclosure</a>
            </div>
          </div>
        </div>
        {/* GitHub contribution graph - full width */}
        <div className="mb-8">
          <a href="https://github.com/hackingpain" target="_blank" rel="noopener noreferrer" className="block">
            <img
              src="https://ghchart.rshah.org/0abfda/hackingpain"
              alt="GitHub contribution graph"
              className="w-full max-w-2xl rounded opacity-60 hover:opacity-100 transition"
              loading="lazy"
            />
          </a>
        </div>
        <div className="border-t pt-8 text-left" style={{ borderColor: 'var(--border)', color: 'var(--muted)' }}>
          <p className="mb-2 font-mono text-sm">&copy; {new Date().getFullYear()} Domenic Laurenzi. All rights reserved.</p>
          <p className="text-sm">Mission-driven cybersecurity for healthcare, education, and government.</p>
          <p className="text-sm mt-2">
            Built with React + Tailwind CSS
          </p>
        </div>
      </div>
    </footer>
  );
}
